var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_1491d0a4"]},_vm.$listeners),[_c('cube-slider',{on:{"change":(e)=>_vm.__invoke(e, [["handleChange"]]),"changing":(e)=>_vm.__invoke(e, [["handleChanging"]])}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }